import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { LoadingInterceptor } from '@core/interceptors/loading.interceptor';
import { BuildInfoStore } from '@core/build/build-info.store';
import { BuildIdTranslateLoader } from '@core/i18n/build-id-translate-loader';
import { OnDemandPreloadStrategy } from '@core/preloaders/on-demand-preload.strategy';

function initializeBuildInfo(buildInfoStore: BuildInfoStore) {
    return () => buildInfoStore.load();
}

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        MatProgressBarModule,
        RouterModule.forRoot(appRoutes, {
            useHash: true,
            preloadingStrategy: OnDemandPreloadStrategy,
            onSameUrlNavigation: 'reload',
            // enableTracing: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: BuildIdTranslateLoader,
            },
        }),
        CoreModule,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeBuildInfo,
            deps: [BuildInfoStore],
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    ],
})
export class AppModule {}
